import { render } from "./PlusElipseIcon.vue?vue&type=template&id=5b072ea5"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/PlusElipseIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b072ea5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b072ea5', __exports__)) {
    api.reload('5b072ea5', __exports__)
  }
  
  module.hot.accept("./PlusElipseIcon.vue?vue&type=template&id=5b072ea5", () => {
    api.rerender('5b072ea5', render)
  })

}


export default __exports__